
/**
 * Copyright (c) 20240701, Mohamed eRrais (merrais / MeR) 
 * from tajwyd.akademy.ma
 * logo.png Compressed from digitalservices.ma
 */

import {arConfig} from './ar';

export const esConfig = {
    ...arConfig.base,
    salaam:'Salaam',

home : {
    ...arConfig.home,
    login:'Login',
    about:'Moshaf Service to read and learn and memorize Al Quraan every time and everywhere',
    article : 'Articles',
    contact : 'Contact',
},

profile : {
    profile : 'Profile',
    audio : 'Audio',
    monitor:'Monitor',
    akademy : 'Akademy',
    akademyApp : 'AkademyApp',
    setting : 'Settings',
}
}